import axios from 'axios';

export default {
  loadFoodResources () {
    return new Promise(resolve => {
      axios.get(`https://datahub-datasets.s3.amazonaws.com/Uploads/AutomatedJobs/FoodResources.json?&timestamp=${new Date().getTime()}`).then((result) => {
        let data = result.data;
        data.map(r => {
          r.lat = parseFloat(r.Lat)
          r.lng = parseFloat(r.Lng)
        })
        resolve(data);
      });
    })
  }
}



// WEBPACK FOOTER //
// ./src/components/foodResources/foodResources.service.js